import {NewTableDef} from "../../shared/tables/table-column-def";

export class FeaturesListQuery {
    public Id: number;
    public Name: string;
    public Type: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CartListQuery',
            columns: [
                { columnDef: 'id' },
                {
                    field: 'name',
                    columnDef: 'name',
                    header: 'Nazwa',
                    isGeneralSearchColumn: true,
                    tooltipEnabled: true,
                    width: 30
                },
                {
                    field: 'type',
                    columnDef: 'type',
                    header: 'Rodzaj',
                    width: 15,
                    showSearch: false
                },
                {
                    field: 'createdByUserName',
                    columnDef: 'createdByUserName',
                    header: 'Właściciel cechy',
                    width: 15,
                },
                {
                    field: 'updatedAt',
                    columnDef: 'updatedAt',
                    header: 'Data edycji',
                    width: 15,
                    type: 'datetime',
                    showSearch: false
                },
                {
                    field: 'updatedByUserName',
                    columnDef: 'UpdatedByUserName',
                    header: 'Ostatni edytor',
                    width: 15,
                }
            ]
        };
    }
}
